export default __webpack_public_path__ + "static/media/leipzig.ba47fd59.png";